import { ItemType } from "~/utils/enums/common.enums";

/** Chat resource types not represented by the frontend's existing ItemType enum. */
export enum CopilotResourceItemTypeEnum {
  TRAINING = "training",
  ORDER_EVENT = "orderEvent",
  PROJECT_USER = "projectUser",
  BUCKET = "bucket",
  THREE_SIXTY_USER = "threeSixtyUser",
  THREE_SIXTY_GROUP = "threeSixtyGroup",
  THREE_SIXTY_PATH = "threeSixtyPath",
  THREE_SIXTY_TAG = "threeSixtyTag",
  THREE_SIXTY_PATH_SESSION = "threeSixtyPathSession",
  THREE_SIXTY_PATH_STATISTIC = "threeSixtyPathStatistic",
  THREE_SIXTY_ENROLLMENT = "threeSixtyEnrollment",
  DOCEBO_USER = "doceboUser",
  DOCEBO_GROUP = "doceboGroup",
  DOCEBO_CATEGORY = "doceboCategory",
  DOCEBO_COURSE = "doceboCourse",
  DOCEBO_SESSION = "doceboSession",
  DOCEBO_ENROLLMENT = "doceboEnrollment",
  DOCEBO_EVENT = "doceboEvent",
  DOCEBO_ATTENDANCE = "doceboAttendance",
}

/** Exact backend allowlist: do not widen this to all of ItemType. */
export const COPILOT_RESOURCE_ITEM_TYPES = [
  ItemType.SESSION,
  ItemType.PROJECT,
  ItemType.REQUEST,
  ItemType.BOOKING,
  ItemType.HABILITATION,
  ItemType.USER,
  ...Object.values(CopilotResourceItemTypeEnum),
] as const;

export type CopilotResourceItemType = (typeof COPILOT_RESOURCE_ITEM_TYPES)[number];
